/**
 * Formats a bank amount in its own currency.
 *
 * The provider reports the currency per account, so nothing here may hard-code EUR — and an
 * unknown or empty code would make Intl throw and take the whole table down.
 *
 * @param signed Shows an explicit + on incoming amounts. Use it wherever the sign carries the
 *               meaning (Eingang/Ausgang) instead of just marking a deduction.
 */
export const formatAmount = (amount: number, currency?: string | null, signed = false) => {
    const options: Intl.NumberFormatOptions = {
        style: 'currency',
        currency: currency || 'EUR',
        signDisplay: signed ? 'exceptZero' : 'auto'
    };

    try {
        return new Intl.NumberFormat('de-DE', options).format(amount);
    } catch {
        return new Intl.NumberFormat('de-DE', { ...options, currency: 'EUR' }).format(amount);
    }
};

/** Formats an ISO date string as a German date, or an em dash when there is none. */
export const formatDate = (value?: string | null) =>
    value ? new Date(value).toLocaleDateString('de-DE') : '—';
